import { type DeepPartial, type HttpError, type SearchListing, type SearchListingsFilters } from '@ev-tech/search-modules-api';

import { type TFunction } from '../providers/AppContextProvider';
import { type SearchMode } from '../hooks/stores/search/slices/searchModeSlice';
import { type MapMode } from '../hooks/stores/search/slices/mapInteractionSlice';
import { type BeforeFiltersChange } from '../hooks/stores/search/SearchStoreProvider';
import { type SortingOptionId } from '../enums/enums';

export type FilterRefinement = DeepPartial<SearchListingsFilters>;

export type WithTestId<T = Record<string, unknown>> = T & {
  'data-testid'?: string;
};

export type GetToken = (options?: object) => Promise<string | null>;

export type UserAccountProps = {
  translationResolver: TFunction;
};

export type SearchModuleEvents = {
  onUrlUpdate?: (url: string) => void;
  onWatchlistClick?: (property: SearchListing) => void;
  onIsMapViewChange?: (isMapView: boolean) => void;
  onResultsChange?: (results: SearchListing[]) => void;
  onBeforeFiltersChange?: BeforeFiltersChange;
  onFiltersChange?: (filters: SearchListingsFilters) => void;
  onError?: (error: Error | HttpError, context?: Record<string, unknown>) => void;
};

export type SeoPageLink = {
  text: string;
  url: string;
};

export type AutogenConfig = {
  isLuxury: boolean;
  seoPagesLinks: SeoPageLink[];
};

export const PendingUserAccountItemType = {
  WATCHLIST: 'watchlist',
  SEARCH_ALERT: 'search-alert',
  UA_EXCLUSIVE_EXPOSE: 'ua-exclusive-expose',
} as const;

export type PendingUserAccountItemType = (typeof PendingUserAccountItemType)[keyof typeof PendingUserAccountItemType];

export type PendingUserAccountItem = {
  type: PendingUserAccountItemType;
  data?: SearchListing;
  uAExclusiveAuthExposeUrl?: string;
};

export type AdditionalUiStateParams = {
  sortingOptionId?: SortingOptionId;
  placeName?: string;
  searchMode?: SearchMode;
  mapMode?: MapMode;
  hasSessionBounds?: boolean;
};
